/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import { IErrorProps } from "../../models";

const getErrorForUserPages = (err: any) => {
  const error: IErrorProps = {
    errorCode: err?.status,
    errorMessage:
      typeof err?.data === "string"
        ? err?.data
        : typeof err?.statusText === "string"
        ? err?.statusText
        : "",
  };
  if (error.errorMessage === "" && typeof err?.data?.title === "string") {
    error.errorMessage = err?.data?.title ?? "";
  }
  return error;
};
export default getErrorForUserPages;
